var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.saving)?_c('span',{staticClass:"saving semibold",attrs:{"data-qa":"saving-status"}},[_c('ds-icon',{staticClass:"saving-icon",attrs:{"name":"loader"}}),_c('span',[_vm._v(_vm._s(_vm.$t('funnel.saving')))])],1):_c('DsStatus',{attrs:{"type":"good","data-qa":"save-success","emphasis":"medium"}},[_vm._v(" "+_vm._s(_vm.$t('funnel.saved'))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }